import { render, staticRenderFns } from "./Iniciada.vue?vue&type=template&id=7b28edd4&"
import script from "./Iniciada.vue?vue&type=script&lang=js&"
export * from "./Iniciada.vue?vue&type=script&lang=js&"
import style0 from "./Iniciada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Iniciada.vue"
export default component.exports